/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FilterView } from './FilterView';
import {
    FilterViewFromJSON,
    FilterViewFromJSONTyped,
    FilterViewToJSON,
} from './FilterView';

/**
 * 
 * @export
 * @interface FindAllFilterViews200Response
 */
export interface FindAllFilterViews200Response {
    /**
     * 
     * @type {Array<FilterView>}
     * @memberof FindAllFilterViews200Response
     */
    data?: Array<FilterView>;
}

/**
 * Check if a given object implements the FindAllFilterViews200Response interface.
 */
export function instanceOfFindAllFilterViews200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllFilterViews200ResponseFromJSON(json: any): FindAllFilterViews200Response {
    return FindAllFilterViews200ResponseFromJSONTyped(json, false);
}

export function FindAllFilterViews200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllFilterViews200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(FilterViewFromJSON)),
    };
}

export function FindAllFilterViews200ResponseToJSON(value?: FindAllFilterViews200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(FilterViewToJSON)),
    };
}

